import { render } from "./detailDeclare.vue?vue&type=template&id=59683e44&scoped=true"
import script from "./detailDeclare.vue?vue&type=script&lang=js"
export * from "./detailDeclare.vue?vue&type=script&lang=js"

import "./detailDeclare.vue?vue&type=style&index=0&id=59683e44&lang=scss&scoped=true"
import "./detailDeclare.vue?vue&type=style&index=1&id=59683e44&lang=css"

import exportComponent from "D:\\project\\websites\\zct_v2_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59683e44"]])

export default __exports__